import { AbstractControl } from '@angular/forms';
import { AlarmRuleTriggerType } from '../../../../../../../types/dtos/alarm-rule-trigger.dto';
import { AlarmRuleTriggerFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleTrigger } from '../base-rule-trigger';
import { DeviceInputTrigger } from './device-input-trigger';


export class DeviceInputRuleTrigger extends BaseRuleTrigger {
  public getDescription(): string {
    return 'common.alarm-rule.trigger.device-input.description';
  }

  public getIcon(): string {
    return 'input';
  }

  public getName(): string {
    return 'common.alarm-rule.trigger.device-input.title';
  }

  public getType(): AlarmRuleTriggerType {
    return AlarmRuleTriggerType.DEVICE_INPUT;
  }

  public getEditorComponent(): any {
    return DeviceInputTrigger;
  }

  public configToFrom(data: {}): Record<string, unknown> {
    return {};
  }

  public formToConfig(form: AlarmRuleTriggerFormDto): Record<string, unknown> {
    return {};
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {};
  }
}